export default __webpack_public_path__ + "static/media/logo-sm.a8ade8b1.png";